var map = {
	"./symbol_11_normal.png": 6560,
	"./symbol_12_normal.png": 25365,
	"./symbol_13_normal.png": 45406,
	"./symbol_14_normal.png": 17147,
	"./symbol_15_normal.png": 1812,
	"./symbol_16_normal.png": 7833,
	"./symbol_17_normal.png": 4437,
	"./symbol_18_normal.png": 17871,
	"./symbol_19_normal.png": 9240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12011;